import { addMailListLog, getMailListLogObjectToAddToStore } from 'owa-mail-list-logging';
import tombstoneOperations, { type TombstoneReasonType } from 'owa-mail-list-tombstone';
import type { MailListRowDataType, TableView } from 'owa-mail-list-store';

/**
 * Function that evaluates if the row payload should be processed when it is
 * received from the server, during merge and stitch operations. We want to skip processing
 * rows that are tombstoned for the Read reason when the feature is enabled to prevent flickering
 * of the read/unread states in the UI during the merge/stitch operations and also to prevent
 * having the incorrect state stick.
 * @param serverRow row payload received from server
 * @param tableView to which the row belongs
 * @returns a flag indicating whether the row should be processed further or not
 */
export default function shouldSkipProcessReadTombstonedRow(
    serverRow: MailListRowDataType,
    tableView: TableView
): boolean {
    const tombstoneReasons = serverRow.InstanceKey
        ? tombstoneOperations.getTombstonedReasons(serverRow.InstanceKey, tableView)
        : [];

    if (tombstoneReasons.indexOf(2) > -1) {
        addMailListLog(
            getMailListLogObjectToAddToStore('shouldSkipProcessReadTombstonedRow:', {
                rowInstanceKey: serverRow.InstanceKey,
                tombstoneReasons: tombstoneReasons.join(', '),
            })
        );
        return true;
    }
    return false;
}
